import { useGlobalState } from '@highlight/ipc/react'
import { clearCurrentDetection, DetectedType } from '@shared/store/impl/detection.ts'
import { useCallback, useMemo } from 'react'

export const useClipboardActivity = () => {
  const [detection] = useGlobalState<DetectedType>('currentDetection')

  const detectedClipboardText = useMemo(() => {
    if (detection?.type !== 'clipboardText') {
      return undefined
    }
    return detection.value
  }, [detection])

  const clearDetectedClipboard = useCallback(() => {
    clearCurrentDetection('clipboardText')
  }, [])

  return useMemo(() => {
    return {
      detectedClipboardText,
      clearDetectedClipboard,
    }
  }, [detectedClipboardText, clearDetectedClipboard])
}
